import type { ReactNode } from "react";
import { useCarousel } from "../../../elements/carousel/hooks";
import type { Optional } from "../../../types";
import type { VehicleCardImageProps } from "../vehicle-card.component";
import styles from "./vehicle-card-image-desktop.module.css";

export type VehicleCardImageDesktopProps = {
  src: string;
  title: string;
  index: number;
  onImageRender?: Optional<(props: VehicleCardImageProps) => ReactNode>;
};

export function VehicleCardImageDesktop({
  src,
  title,
  index,
  onImageRender,
}: Readonly<VehicleCardImageDesktopProps>) {
  const { index: activeIndex } = useCarousel();

  const isActive = activeIndex === index;

  const props = {
    src,
    title,
    index,
    isActive,
    height: 190,
    width: 242,
    alt: title,
    className: styles.Image,
  };

  return (
    <div className={styles.Container} data-active={isActive}>
      {onImageRender ? onImageRender(props) : <img {...props} />}
    </div>
  );
}
